module.exports = __webpack_public_path__ + "static/media/megamenu-img.913183e4.png";